module.exports = __webpack_public_path__ + "img/main-logo-naotravelco.33746ca3.png";